module.exports = __webpack_public_path__ + "img/Logo_white.1543b532.png";